import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface GuardRailViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class GuardRailViewPage extends Component<GuardRailViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.guard_rail.view }}
                pages={{
                    entity: InferenceEntities.guard_rail(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}